import { ToggleButton } from "plos/src/components/ToggleButton";
import { ToggleButtonGroup } from "plos/src/components/ToggleButtonGroup";
import type { Key } from "react-aria-components";
import { useTranslation } from "react-i18next";
import type { PitchView } from "../../hooks/usePitchView";
import { OverlayDropdown } from "./OverlayDropdown";
import { pitchControlsWrap, pitchViewToggle } from "./pitchControls.css";
import { PitchControlsProps } from "./types";

const PitchControls = ({
  activeView,
  handleViewChange,
}: PitchControlsProps) => {
  const { t } = useTranslation("common");
  const handleSelectionChange = (keys: Set<Key>) => {
    handleViewChange(keys as Set<PitchView>);
  };

  return (
    <div className={pitchControlsWrap}>
      <div className={pitchViewToggle}>
        <ToggleButtonGroup
          selectedKeys={new Set([activeView])}
          onSelectionChange={handleSelectionChange}
        >
          <ToggleButton id="pitch">
            {t("pitchControls.viewSelector.pitch", "Pitch")}
          </ToggleButton>
          <ToggleButton id="list">
            {t("pitchControls.viewSelector.list", "List")}
          </ToggleButton>
        </ToggleButtonGroup>
      </div>
      <OverlayDropdown />
    </div>
  );
};

export default PitchControls;
